import { Component, inject } from '@angular/core';
import { SafeScriptComponent } from '../../script-injector/safe-script/safe-script.component';
import { SurveyRenderControllerStore } from '../../render-store/render.store';

@Component({
  selector: 'lib-survey-completed',
  imports: [SafeScriptComponent],
  templateUrl: './survey-completed.html',
  styleUrl: './survey-completed.css',
})
export class SurveyCompleted {
  renderStore = inject(SurveyRenderControllerStore);
}
